import axios from "axios";
import { useAuth } from "@clerk/react";
import { useCallback } from "react";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const rupiah = (n) => "Rp" + Number(n || 0).toLocaleString("id-ID");

export const priceFor = (count, prices) => {
  if (!prices || !count) return 0;
  return count === 1 ? prices["1"] : count === 2 ? prices["2"] : prices["3"];
};

export const normalizeWa = (raw = "") => {
  const d = raw.replace(/\D/g, "");
  return d.startsWith("0") ? "62" + d.slice(1) : d;
};

export const waLink = (number, message = "") =>
  `https://wa.me/${normalizeWa(number)}${message ? `?text=${encodeURIComponent(message)}` : ""}`;

export const errMsg = (e, fallback = "Terjadi kesalahan") => {
  const d = e?.response?.data?.detail;
  return typeof d === "string" ? d : fallback;
};

export const STATUS_META = {
  menunggu: { label: "Menunggu Verifikasi", cls: "bg-yellow-500/15 text-yellow-300 border-yellow-500/40" },
  terverifikasi: { label: "Terverifikasi", cls: "bg-emerald-500/15 text-emerald-300 border-emerald-500/40" },
  ditolak: { label: "Ditolak", cls: "bg-red-500/15 text-red-300 border-red-500/40" },
  terkirim: { label: "Foto Terkirim", cls: "bg-sky-500/15 text-sky-300 border-sky-500/40" },
};

export function useApi() {
  const { getToken } = useAuth();
  return useCallback(
    async (method, url, data, extra = {}) => {
      const token = await getToken();
      return axios({ method, url: `${API}${url}`, data, headers: { Authorization: `Bearer ${token}` }, ...extra });
    },
    [getToken]
  );
}
